/* HVAC lead generation worksheet. Local arithmetic only. No storage, network requests, or marketing events. */
(function () {
  'use strict';
  function money(n) { return Math.round((n + Number.EPSILON) * 100) / 100; }
  function whole(value, label, min) {
    if (value === undefined || value === null || String(value).trim() === '') throw new Error('Enter ' + label + '.');
    var n = Number(value);
    if (!Number.isFinite(n) || n < 0 || n > 1000000000 || Math.floor(n) !== n) throw new Error('Enter ' + label + ' as a whole number.');
    if (min !== undefined && n < min) throw new Error('Enter ' + label + ', at least ' + min + '.');
    return n;
  }
  function amount(value, label, optional) {
    if (value === undefined || value === null || String(value).trim() === '') {
      if (optional) return null;
      throw new Error('Enter ' + label + '.');
    }
    var n = Number(value);
    if (!Number.isFinite(n) || n < 0 || n > 1000000000) throw new Error('Check ' + label + '.');
    return n;
  }
  function sourceCheck(input) {
    var spend = amount(input.spend, 'the monthly spend');
    var leads = whole(input.leads, 'how many leads it sent you', 1);
    var reached = whole(input.reached, 'how many leads your team reached');
    var booked = whole(input.booked, 'how many visits were booked');
    var closed = whole(input.closed, 'how many jobs closed');
    var value = amount(input.value, 'the average job value', true);
    if (reached > leads) throw new Error('Leads your team reached cannot be more than the leads it sent you.');
    if (booked > reached) throw new Error('Visits booked cannot be more than the leads your team reached.');
    if (closed > booked) throw new Error('Jobs closed cannot be more than the visits booked.');
    function per(count) { return count > 0 ? money(spend / count) : null; }
    return {
      spend: spend, leads: leads, reached: reached, booked: booked, closed: closed, value: value,
      unreached: leads - reached,
      perLead: per(leads), perReached: per(reached), perBooked: per(booked), perClosed: per(closed),
      revenue: value !== null ? money(closed * value) : null,
      perDollar: value !== null && spend > 0 ? money(closed * value / spend) : null
    };
  }
  if (typeof module !== 'undefined' && module.exports) module.exports = { sourceCheck: sourceCheck };
  if (typeof document === 'undefined') return;

  var dollars = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' });
  document.querySelectorAll('[data-hlg-calc]').forEach(function (form) {
    var out = form.querySelector('[data-hlg-result]');
    var error = form.querySelector('[data-hlg-error]');
    function clear() { out.replaceChildren(); out.hidden = true; error.textContent = ''; }
    function line(label, text) {
      var p = document.createElement('p');
      var b = document.createElement('strong');
      b.textContent = label + ': ';
      p.append(b, document.createTextNode(text));
      out.append(p);
    }
    function cost(n) { return n === null ? 'not available, because the count is zero' : dollars.format(n); }
    form.addEventListener('input', clear);
    form.addEventListener('reset', clear);
    form.addEventListener('submit', function (event) {
      event.preventDefault();
      clear();
      try {
        var r = sourceCheck({
          spend: form.elements.namedItem('spend').value,
          leads: form.elements.namedItem('leads').value,
          reached: form.elements.namedItem('reached').value,
          booked: form.elements.namedItem('booked').value,
          closed: form.elements.namedItem('closed').value,
          value: form.elements.namedItem('value').value
        });
        line('Cost per lead', dollars.format(r.spend) + ' divided by ' + r.leads + ' leads = ' + cost(r.perLead));
        line('Leads nobody reached', r.unreached + ' of ' + r.leads);
        line('Cost per reached lead', dollars.format(r.spend) + ' divided by ' + r.reached + ' = ' + cost(r.perReached));
        line('Cost per booked visit', dollars.format(r.spend) + ' divided by ' + r.booked + ' = ' + cost(r.perBooked));
        line('Cost per closed job', dollars.format(r.spend) + ' divided by ' + r.closed + ' = ' + cost(r.perClosed));
        if (r.revenue !== null) {
          line('Job value from this source', r.closed + ' jobs times ' + dollars.format(r.value) + ' = ' + dollars.format(r.revenue));
          if (r.perDollar !== null) line('Job value for each $1 spent', dollars.format(r.revenue) + ' divided by ' + dollars.format(r.spend) + ' = ' + dollars.format(r.perDollar));
        }
        var note = document.createElement('p');
        note.className = 'hlg-calc__sum';
        note.textContent = 'Every figure comes from the numbers you typed.';
        out.append(note);
        out.hidden = false;
        out.focus();
      } catch (e) {
        error.textContent = e.message;
      }
    });
  });
})();
